import { Instance, SnapshotIn, SnapshotOut, types } from 'mobx-state-tree';
import { User } from './user/user';
import { Data } from './app/data';
import { I18n } from './i18n/i18n';
import { PageProject } from './page-project/pageProject';
import { BottomSheet } from './bottom-sheet/bottomSheet';
import { DynamicModal } from './dynamic-modal/dynamicModal';
import { ToolbarDesktop } from './toolbar-desktop/toolbarDesktop';
import { GoogleAccount } from './google-account/googleAccount';
import { ToastStore } from './toast/toastStore';
import { Drawer } from './drawer/drawer';
import { BOTTOM_SHEET_DEFAULT_VALUES } from './bottom-sheet/bottomSheet.constants';
import { DRAWER_DEFAULT_VALUES } from './drawer/drawer.constants';
import { PhotoDrawer } from './photo-drawer/photoDrawer';
import { PHOTO_DRAWER_DEFAULT_VALUES } from './photo-drawer/photoDrawer.constants';
import { Tutorial } from './tutorial/tutorial';

const RootStore = types.model('RootStore', {
  isStoreReady: types.boolean,
  user: User,
  data: types.optional(Data, {
    isLoading: true,
  }),
  i18n: types.optional(I18n, {}),
  project: types.optional(PageProject, {}),
  bottomSheet: types.optional(BottomSheet, BOTTOM_SHEET_DEFAULT_VALUES),
  dynamicModal: types.optional(DynamicModal, {
    stackedModals: [],
  }),
  toolbarDesktop: types.optional(ToolbarDesktop, {
    isToolbarOpen: false,
  }),
  googleAccount: types.optional(GoogleAccount, {}),
  toastStore: types.optional(ToastStore, {}),
  drawer: types.optional(Drawer, DRAWER_DEFAULT_VALUES),
  photoDrawer: types.optional(PhotoDrawer, PHOTO_DRAWER_DEFAULT_VALUES),
  tutorial: types.optional(Tutorial, { projectId: '', tutorialVisible: false }),
});

interface IRootStore extends Instance<typeof RootStore> {}
interface IRootStoreSnapshotIn extends SnapshotIn<typeof RootStore> {}
interface IRootStoreSnapshotOut extends SnapshotOut<typeof RootStore> {}

export { RootStore, IRootStore, IRootStoreSnapshotIn, IRootStoreSnapshotOut };
